var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select-input',{attrs:{"id":_vm.id,"edit-mode":_vm.editMode,"value":_vm.value,"value-property":"code","label-property":"code","tag-preview":"","options":_vm.options},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }